module.exports = __webpack_public_path__ + "img/diagnosis-report-avatar-default.1e6bdd8d.png";